/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Experience source type
 * @example "NOVA"
 */
export enum ExperienceSource {
  NOVA = "NOVA",
  SIP = "SIP",
  NOVANET = "NOVANET",
  INTERNAL = "INTERNAL",
}

/**
 * Flow internal unique code associated with content type
 * @example "CURATION"
 */
export enum FlowCode {
  CURATION = "CURATION",
  MANUAL_TRANSLATION = "MANUAL_TRANSLATION",
  MEDIA = "MEDIA",
  AUTOTRANSLATION = "AUTOTRANSLATION",
}

/**
 * Status code.
 * @example "IN_REVIEW"
 */
export enum StatusCode {
  IN_REVIEW = "IN_REVIEW",
  TO_BE_EDIT = "TO_BE_EDIT",
  READY = "READY",
}

/**
 * Media type
 * @example "GALLERY"
 */
export enum ImageType {
  COVER = "COVER",
  GALLERY = "GALLERY",
  THUMB = "THUMB",
}

/**
 * Measure of space a file takes up on a storage medium. It's categorized in internal codes .
 * @example "SMALL"
 */
export enum Size {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  BIG = "BIG",
  EXTRA_LARGE = "EXTRA_LARGE",
  LPP = "LPP",
  DYNAMIC = "DYNAMIC",
}

/**
 * Type of translation indicating how the content was translated
 * @example "MANUAL"
 */
export enum TranslationType {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export interface Error {
  /** @example "GenericApiException" */
  code?: string;
  /** @example "Error message description" */
  message?: string;
}

export type StatusAllowed = StatusId[];

export interface TransitionFlow {
  statuses_backward_allowed?: TransitionsArray;
  statuses_forward_allowed?: TransitionsArray;
}

export interface Flow {
  /** Entity internal unique code */
  id: IdReadonly;
  /** Internal code */
  code: Code;
  status_allowed?: StatusAllowed;
  /** First status that acquire a content element when it's created */
  init_status: InitStatus;
  /** Final status that indicates that a flow is complete and the content is ready for published */
  end_status: EndStatus;
  /** Alternative end status that indicates that a  flow is completed but the content can't be published still */
  alternative_status?: AlternativeStatus;
}

export interface ExperienceMedia {
  /** Entity internal unique code */
  id?: IdReadonly;
  /** Experience id to which the entity belongs */
  experience_id?: ExperienceId;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  images_v2?: ImageV2Ids;
  /** Experience source type */
  source?: ExperienceSource;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

/**
 * Final status that indicates that a flow is complete and the content is ready for published
 * @example "READY"
 */
export type EndStatus = string;

/**
 * Alternative end status that indicates that a  flow is completed but the content can't be published still
 * @format uuid
 * @example "91b677a7-7733-4452-bb81-8501e073c45f"
 */
export type AlternativeStatus = string;

/**
 * First status that acquire a content element when it's created
 * @example "TO_BE_EDITED"
 */
export type InitStatus = string;

export type TransitionsArray = StatusId[];

export interface TranslationElement {
  /** Entity internal unique code */
  id?: IdReadonly;
  /** Language code */
  language_code: LanguageCode;
  /** Entity name. */
  name?: Name;
  /** Translation description. */
  text1?: Description;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Should the entity be translated automatically? */
  to_be_translated?: ToBeTranslated;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export type ExperienceTranslation = TranslationElement & {
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /** Product title */
  title: Title;
  /** Translation second description. */
  text2?: SecondDescription;
  /** Translation third description. */
  text3?: ThirdDescription;
  /** Seo meta title. */
  seo_title?: SeoTitle;
  /** Seo meta description. */
  seo_description?: SeoDescription;
  info_voucher?: InfoVoucher;
  meeting_point_details?: MeetingPointDetails;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Human review */
  curation_quality?: CurationQuality;
  /** Unpublish date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  unpublish_date?: UnpublishDate;
  /** Experience source type */
  source?: ExperienceSource;
};

export type ExperienceTranslationV2 = ExperienceTranslation & {
  /** Type of translation indicating how the content was translated */
  translation_type: TranslationType;
};

export type ImageV2Ids = MediaItemV2[];

export interface MediaItem {
  /** Media element internal unique code */
  id?: IdMediaItem;
  /** Visualization order */
  visualization_order?: VisualizationOrder;
  /** Item is cover */
  is_cover?: IsCover;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface MediaItemV2 {
  /** Media element internal unique code */
  id?: IdMediaItem;
  /** Visualization order */
  visualization_order?: VisualizationOrder;
  /** Media type */
  image_type?: ImageType;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface ExperienceCommercialContent {
  /** Entity internal unique code */
  id?: IdReadonly;
  /** Supplier id media owner */
  supplier_id?: SupplierId;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  experience_translations?: ExperienceTranslationItem[];
  /** Experience media id */
  experience_media_id?: ExperienceMediaId;
}

export interface ExperienceTranslationItem {
  /** Entity internal unique code */
  id: Id;
  /** Language code */
  language_code: LanguageCode;
}

export interface CustomIncluded {
  /**
   * @format uuid
   * @example "7c531efc-ec15-45e2-a9be-3e9a2fbe0864"
   */
  id: string;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /**
   * Internal code for includes
   * @example "ENTRANCEFEES"
   */
  code?: string;
  /**
   * Language Code
   * @example "en"
   */
  language_code: string;
  /**
   * Name of the includes
   * @example "Entrance fees"
   */
  name: string;
  /**
   * Description of the includes
   * @example "Description if it needs"
   */
  description?: string;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Should the entity be translated automatically? */
  to_be_translated?: ToBeTranslated;
  /** Visualization order */
  visualization_order?: VisualizationOrder;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Experience source type */
  source?: ExperienceSource;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface CustomNonIncluded {
  /**
   * @format uuid
   * @example "7c531efc-ec15-45e2-a9be-3e9a2fbe0864"
   */
  id: string;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /**
   * Internal code for non includes
   * @example "ENTRANCEFEES"
   */
  code?: string;
  /**
   * Language Code
   * @example "en"
   */
  language_code: string;
  /**
   * Name of the non includes
   * @example "Entrance fees"
   */
  name: string;
  /**
   * Description of the non includes
   * @example "Description if it needs"
   */
  description?: string;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Should the entity be translated automatically? */
  to_be_translated?: ToBeTranslated;
  /** Visualization order */
  visualization_order?: VisualizationOrder;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Experience source type */
  source?: ExperienceSource;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface CustomHighlights {
  /**
   * @format uuid
   * @example "32d06ab9-dcd7-4cef-8ea3-cf989799f4a9"
   */
  id: string;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /**
   * Internal code used for custom highlights
   * @example "LUNCHMENU"
   */
  code?: string;
  /**
   * Language Code
   * @example "en"
   */
  language_code: string;
  /**
   * Custom highlight's name
   * @example "Lunch menu to keep you going all the day"
   */
  name: string;
  /**
   * Custom highlight's description
   * @example "Description if it needs"
   */
  description?: string;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Should the entity be translated automatically? */
  to_be_translated?: ToBeTranslated;
  /** Visualization order */
  visualization_order?: VisualizationOrder;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Experience source type */
  source?: ExperienceSource;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface ImageV2 {
  /** Entity internal unique code */
  id: IdReadonly;
  /** File name */
  file_name: FileName;
  /** Preview URL */
  preview_url?: PreviewUrl;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface CustomImportantInformation {
  /**
   * @format uuid
   * @example "32d06ab9-dcd7-4cef-8ea3-cf989799f4a9"
   */
  id: string;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /**
   * Internal code for "things to remember"
   * @example "COPYPASS"
   */
  code?: string;
  /**
   * Language Code
   * @example "en"
   */
  language_code: string;
  /**
   * Important information's name
   * @example "Copy of your password"
   */
  name: string;
  /**
   * Object's description
   * @example "Description if it needs"
   */
  description?: string;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Should the entity be translated automatically? */
  to_be_translated?: ToBeTranslated;
  /** Visualization order */
  visualization_order?: VisualizationOrder;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Experience source type */
  source?: ExperienceSource;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface TranslationRequest {
  language_list: LanguageTranslation[];
}

export interface TranslationReleaseRequest {
  /**
   * Array of language codes (at least one required)
   * @minItems 1
   */
  language_list: string[];
  /**
   * Offer classification type that determines translation flow behavior. Optional: when null or omitted, new translations default to AUTOMATIC translation type (AUTOTRANSLATION flow) and are released immediately on the first execution. Deprecated since 2026.09.02.1, for removal: kept only for backward compatibility with in-progress EMOS migrations and will be removed once those migrations are complete. New clients should omit this field.
   * @deprecated
   * @example "OWN_OFFER_3P_DESIGNED_OPERATED"
   */
  own_offer_classification?:
    | "OWN_OFFER_TUI_DESIGNED_OPERATED"
    | "OWN_OFFER_TUI_DESIGNED_3P_OPERATED"
    | "OWN_OFFER_3P_DESIGNED_OPERATED"
    | "OWN_OFFER_PARTNER_DESIGNED_TUI_OPERATED"
    | null;
}

export interface LanguageTranslation {
  /** Language code */
  language_code: LanguageCodeEs;
  /** Should the entity be translated automatically? */
  to_be_translated: ToBeTranslated;
  /** Should need a manual translation? */
  automatic_review: AutomaticReview;
}

/**
 * Preview URL
 * @example "https://fotoware.com/images/boat_experience_image.jpg"
 */
export type PreviewUrl = string;

/**
 * File name
 * @example "boat_experience_image"
 */
export type FileName = string;

/** Visualization order */
export type VisualizationOrder = number;

/**
 * Specifies de width of an image in pixels
 * @example 80
 */
export type Width = number;

/**
 * Specifies de height of an image in pixels
 * @example 15
 */
export type Height = number;

/** @format binary */
export type ContentFile = File;

/**
 * Item is cover
 * @example true
 */
export type IsCover = boolean;

/**
 * Media type
 * @example "image/png,audio/mpeg..."
 */
export type MediaType = string;

/**
 * Translation description.
 * @format string
 * @example "Translation description"
 */
export type Description = string;

/**
 * Translation second description.
 * @format string
 * @example "Translation second description"
 */
export type SecondDescription = string;

/**
 * Translation third description.
 * @format string
 * @example "Translation third description"
 */
export type ThirdDescription = string;

/**
 * Seo meta title.
 * @format string
 * @example "Seo meta title"
 */
export type SeoTitle = string;

/**
 * Seo meta description.
 * @format string
 * @example "Seo meta description"
 */
export type SeoDescription = string;

/** @example "Info voucher" */
export type InfoVoucher = string;

/** @example "Meeting point details" */
export type MeetingPointDetails = string;

/**
 * Entity name.
 * @format string
 * @example "Entity name"
 */
export type Name = string;

/**
 * Creator of the item in the first instance.
 * @format string
 * @example "LORD BYRON"
 */
export type Owner = string;

/**
 * Creation date
 * @format date
 * @example "2022-02-18"
 */
export type Datetime = string;

/**
 * Unpublish date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ)
 * @example "2022-04-10T10:15:66Z"
 */
export type UnpublishDate = string;

/**
 * Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ)
 * @example "2022-04-10T10:15:66Z"
 */
export type CreationDate = string;

/**
 * Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ)
 * @example "2022-05-20T10:15:66Z"
 */
export type UpdatedDate = string;

/**
 * Item has been signed
 * @example true
 */
export type Signature = boolean;

/**
 * Experience id to which the entity belongs
 * @format uuid
 * @example "5281000c-952f-4ed0-9ca5-a63d1b653041"
 */
export type ExperienceId = string;

/**
 * Internal code
 * @example "MEDIA"
 */
export type Code = string;

/**
 * Option for the Operational Information
 * @format uuid
 * @example "5281000c-952f-4ed0-9ca5-a63d1b653041"
 */
export type OptionId = string;

/**
 * Status id.
 * @format uuid
 * @example "fc2e9c6b-8f9e-4bc4-b669-f10623a39740"
 */
export type StatusId = string;

/**
 * Was the entity automatically translated?
 * @example true
 */
export type AutomaticTranslation = boolean;

/**
 * Should the entity be translated automatically?
 * @example true
 */
export type ToBeTranslated = boolean;

/**
 * Should need a manual translation?
 * @example true
 */
export type AutomaticReview = boolean;

/**
 * Human review
 * @example true
 */
export type CurationQuality = boolean;

/**
 * Product title
 * @example "Product title"
 */
export type Title = string;

/**
 * Entity internal unique code
 * @format uuid
 * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
 */
export type IdReadonly = string;

/**
 * Media element internal unique code
 * @format uuid
 * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
 */
export type IdMediaItem = string;

/**
 * Flow internal unique code associated with content type
 * @format uuid
 * @example "075343be-aa67-435b-bab3-9b1f5818b649"
 */
export type FlowId = string;

/**
 * Language code
 * @format string
 * @example "en"
 */
export type LanguageCode = string;

/**
 * Language code
 * @format string
 * @example "es"
 */
export type LanguageCodeEs = string;

/**
 * Entity internal unique code
 * @format uuid
 * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
 */
export type Id = string;

/**
 * Supplier id media owner
 * @format uuid
 * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
 */
export type SupplierId = string;

/**
 * Experience media id
 * @format uuid
 * @example "2b9a5553-394d-4ef8-8908-a5ff5cad1e5f"
 */
export type ExperienceMediaId = string;

/**
 * Option code
 * @example "GENERAL"
 */
export type OptionCode = string;

/** @example "Full day" */
export type OptionDescription = string;

export interface ExperienceOptionName {
  /** Entity internal unique code */
  id: IdReadonly;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /** Option for the Operational Information */
  option_id: OptionId;
  /**
   * Operational experience ID. Present for INTERNAL experiences, null for others.
   * @format uuid
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  operational_id?: string | null;
  /** Option code */
  code?: OptionCode;
  /** Premade code related to an option name master data */
  premade_code?: OptionPremadeCode;
  translations?: ExperienceOptionNameTranslation[];
  /** Experience source type */
  source?: ExperienceSource;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

export interface ExperienceOptionNameTranslation {
  /** Entity internal unique code */
  id: IdReadonly;
  /** Language code */
  language_code: LanguageCode;
  /** Custom option name value */
  name: OptionName;
  /** Translation description. */
  description?: Description;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}

/**
 * Premade code related to an option name master data
 * @example "2-days-meal"
 */
export type OptionPremadeCode = string;

/**
 * Custom option name value
 * @example "Complete day experience with meals"
 */
export type OptionName = string;

export interface ExperienceOperationalTranslation {
  /** Entity internal unique code */
  id: IdReadonly;
  /** Experience id to which the entity belongs */
  experience_id: ExperienceId;
  /**
   * Operational experience ID
   * @format uuid
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  operational_id: string;
  /**
   * Operational code
   * @example "EXP_CODE_001"
   */
  code?: string;
  /** Language code */
  language_code: LanguageCode;
  /**
   * Curated/translated operational title
   * @example "Mallorca One Day Tour with Jet Ski Adventure"
   */
  name: string;
  /** Flow internal unique code associated with content type */
  flow_code: FlowCode;
  /** Status code. */
  status_code: StatusCode;
  /** Was the entity automatically translated? */
  automatic_translation?: AutomaticTranslation;
  /** Creation date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  creation_date?: CreationDate;
  /** Last updated date in UTC(ISO_8601) format (YYYY-MM-DDTHH:MM:SSZ) */
  updated_date?: UpdatedDate;
}
